import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface RichNotificationLine {
  text: string
  bold?: boolean
  secondary?: boolean
}

export interface RichNotification {
  id: string
  title: string
  lines: RichNotificationLine[]
  autoHideDuration?: number // ms, default 10000
}

interface RichNotificationState {
  notifications: RichNotification[]
}

const initialState: RichNotificationState = {
  notifications: [],
}

export const richNotificationSlice = createSlice({
  name: 'richNotification',
  initialState,
  reducers: {
    addRichNotification: (state, action: PayloadAction<Omit<RichNotification, 'id'>>) => {
      state.notifications.push({
        id: Date.now().toString(),
        ...action.payload,
      })
    },
    removeRichNotification: (state, action: PayloadAction<string>) => {
      state.notifications = state.notifications.filter((n) => n.id !== action.payload)
    },
    clearAllRichNotifications: (state) => {
      state.notifications = []
    },
  },
})

export const { addRichNotification, removeRichNotification, clearAllRichNotifications } =
  richNotificationSlice.actions

export default richNotificationSlice.reducer
